<script>

import EmployerForm from "@/components/users/EmployerForm.vue";

export default {
    components: {EmployerForm},
    data() {
        return {
            errors: {},
            loading: true,
            user: {},
            controller: new AbortController()
        }
    },
    methods: {

    },
    mounted() {
        axios.get(`/users/${this.$route.params.id}`, {
            signal: this.controller.signal
        }).then((response) => {
            this.user = response.data.data;
        }).finally(() => {
            this.loading = false;
        })
    },
    beforeUnmount() {
        this.controller.abort();
    }
}

</script>
<template>
    <div class="employee-edit">

        <loader :loading="loading"/>

        <employer-form v-if="!loading" :user="user"/>

    </div>
</template>
